import type { ReactNode, SVGProps } from "react";

export type ClinicalIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
};

export function ClinicalIconSvg({
  size = 24,
  children,
  ...props
}: ClinicalIconProps & { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
    </svg>
  );
}

export function FillPath(props: SVGProps<SVGPathElement>) {
  return (
    <path
      fill="currentColor"
      fillOpacity={0.16}
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    />
  );
}

export function StrokePath(props: SVGProps<SVGPathElement>) {
  return (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    />
  );
}
